const data = [
    {
        name: "Palm Harbor",
        img: "https://images.unsplash.com/photo-1570129477492-45c003edd2be?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8aG91c2V8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
        location: "2699 Green Valley",
        city: "New York",
        country: "USA",
        movin: "2022-11-05",
        price: 2095,
        type: "House",
        detail1: "3 beds",
        detail2: "2 bathrooms",
        detail3: "5x7 m²"
    },
    {
        name: "Sodhi Garage",
        img: "https://images.unsplash.com/photo-1486006920555-c77dcf18193c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8Z2FyYWdlfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
        location: "Madh Island",
        city: "Bombay",
        country: "IN",
        movin: "2022-11-09",
        price: 245,
        type: "Garage",
        detail1: "20 parts",
        detail2: "3 branches",
        detail3: "2x10 m²"
    },
    {
        name: "Office Hub",
        img: "https://images.unsplash.com/photo-1497215728101-856f4ea42174?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8b2ZmaWNlfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
        location: "Aerodrome",
        city: "Bangalore",
        country: "IN",
        movin: "2022-11-07",
        price: 355,
        type: "Office",
        detail1: "10 offices",
        detail2: "2 parkings",
        detail3: "10x50 m²"
    },
    {
        name: "Gaurav Tower",
        img: "https://images.unsplash.com/photo-1555883006-37d106604feb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8Z2F1cmF2JTIwdG93ZXJ8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
        location: "Jawahar Nagar",
        city: "Jaipur",
        country: "IN",
        movin: "2022-11-09",
        price: 420,
        type: "Other",
        detail1: "30 shops",
        detail2: "2 markets",
        detail3: "50x20 m²"
    },
];

export default data;